<template>
  <!-- <el-container> -->
    <el-header style="text-align: right; font-size: 12px">
      <el-dropdown>
        <i class="el-icon-setting" style="margin-right: 15px"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>查看</el-dropdown-item>
          <el-dropdown-item>新增</el-dropdown-item>
          <el-dropdown-item>删除</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span>王小虎</span>
    </el-header>
  <!-- </el-container> -->
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: null
    }
  },
  mounted () {
    this.userInfo = this.Cookie.get('userInfo')
    if (this.userInfo === undefined || this.userInfo === '') this.$router.push('/login')
  },
  methods: {
  }
})
</script>

<style>
.el-header {
  background-color: #B3C0D1;
  color: #333;
}
.el-aside {
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/Test.vue